'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002421 from "./presto.-Login-Page-View$$anon$21.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00247 from "./presto.-Login-Page-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$6() {
  this.b77 = null;
  this.b6Z = null;
  this.b70 = false;
  this.b78 = null;
  this.b79 = false;
  this.b7c = null;
  this.b75 = null;
  this.b76 = false;
  this.b71 = null;
  this.b72 = false;
  this.b73 = null;
  this.b74 = false;
  this.b7a = false;
  this.b7b = false;
  this.b77 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b7c = "SingleAppToken";
}
export { $c_Lpresto_LoginPageView$$anon$6 as $c_Lpresto_LoginPageView$$anon$6 };
$p = $c_Lpresto_LoginPageView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$6;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$6() {
}
export { $h_Lpresto_LoginPageView$$anon$6 as $h_Lpresto_LoginPageView$$anon$6 };
$h_Lpresto_LoginPageView$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.b77;
});
$p.L = (function() {
  if ((!this.b70)) {
    this.b6Z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b70 = true;
  }
  return this.b6Z;
});
$p.O = (function() {
  if ((!this.b79)) {
    this.b78 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b79 = true;
  }
  return this.b78;
});
$p.E = (function() {
  return this.b7c;
});
$p.t = (function() {
  if ((!this.b76)) {
    this.b75 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b76 = true;
  }
  return this.b75;
});
$p.M = (function() {
  if ((!this.b72)) {
    this.b71 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gu(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gu())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00247.$c_Lpresto_LoginPageView$$anon$7(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.b72 = true;
  }
  return this.b71;
});
$p.Q = (function() {
  if ((!this.b74)) {
    this.b73 = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002421.$c_Lpresto_LoginPageView$$anon$21();
    this.b74 = true;
  }
  return this.b73;
});
$p.w = (function() {
  if ((!this.b7b)) {
    this.b7a = false;
    this.b7b = true;
  }
  return this.b7a;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee134) => ((p) => \u03b4scrutinee134.ade(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_LoginPageView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$6, "presto.LoginPageView$$anon$6", ({
  Mk: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$6 as $d_Lpresto_LoginPageView$$anon$6 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$6.js.map
